import React from "react";
import UserReviews from "../../Components/UserReviews";
import GetInTouch from "../../Components/GetInTouch";
import HowItWorks from "./_components/HowItWorks";
import Factors from "./_components/Factors";
import Leaders from "./_components/Leaders";
import { Helmet } from "react-helmet";
import RewardsAndRecognition from "./_components/RewardsAndRecognition";
import HeroSection from "../../Components/HeroSection/HeroSection";
import Img from "../../assets/images/image";
import TwoColumn from "../../Components/TwoColumn";
import Counter from "../../Components/Counter";
import HowItWorks2 from "./_components/HowItWorks2";

export default function About() {
   return (
      <div className="animation fadeIn">
         <Helmet>
            <title>About Us - Witmates Technologies</title>
            <meta
               name="description"
               content="Witmates is a transformational global IT software company. We deliver exceptional customer service and provide you with reliable and innovative IT solutions."
            />
            <link rel="canonical" href="https://www.witmates.com/about_us" />
         </Helmet>
         <HeroSection
            image={Img.aboutbanner}
            heading={
               <>
                  <span className="witmates-theme-color">Your</span> Idea <span className="witmates-theme-color">Our</span> <br /> <span className="witmates-theme-color">Innovation!</span>
               </>
            }
            description={
               <>
                  Witmates Technologies is a leading IT Staff augmentation company, specializing in Project Development, Staff Augmentation, and Digital Marketing. As an ISO 27001 and CMMI Level 5
                  certified company, we have a dynamic team of over 100+ talented individuals, including developers, recruiters, and strategic thinkers. We continuously evolve to deliver exceptional
                  results and exceed client expectations. For over 5+ years, we have been at the forefront of the industry, providing cutting-edge services to clients worldwide. We have served our
                  expertise services to 70+ clients and dealt with 100+ projects in 30+ countries.
               </>
            }
         />
         {/* Our Mission */}
         <div className="d-flex justify-content-center align-items-center mobPt60 pt100">
            <TwoColumn
               image={Img.mission}
               heading={<>Our Mission</>}
               pageName="MISSION"
               description={`Witmates Technologies provide innovative and reliable IT solutions to our customers and a steadfast commitment to excellence and customer satisfaction. We offer personalized service and support to ensure your success in every project.`}
               buttonName="BUILD TOGETHER"
               redirection="/get-in-touch"
               isZoom={true}
            />
         </div>
         {/* Our Vision */}
         <div className="d-flex justify-content-center align-items-center mobPt60 pt100">
            <TwoColumn
               image={Img.vision}
               heading={<>Our Vision</>}
               pageName="VISION"
               description={`We envision a world where technology is seamlessly integrated into every aspect of life to empower our clients by leveraging technologies towards growth, innovation and competitiveness. We believe in forging partnerships built on a foundation of trust, where mutual respect and shared values pave the way for collaborative success. `}
               buttonName="BUILD TOGETHER"
               redirection="/get-in-touch"
               isZoom={true}
               reverse
            />
         </div>
         <div className="py-md-5 py-sm-0">
            <Counter />
         </div>
         <HowItWorks2 />
         <div className="mt50 mobMt20">
            <RewardsAndRecognition />
         </div>
         <Factors />
         {/*<Leaders />*/}
         <UserReviews />
         <GetInTouch />
      </div>
   );
}
